export default "__VITE_ASSET__ocYH0IsA__"